import React from "react";
import { useI18n } from "@/i18n/I18nProvider";

function Section({ title, body }) {
  return (
    <section className="zx-legal__section">
      <h2>{title}</h2>
      <p>{body}</p>
    </section>
  );
}

export default function Terms() {
  const { t } = useI18n();
  return (
    <article className="zx-legal">
      <header className="zx-legal__head">
        <h1>{t("terms.title")}</h1>
        <p className="zx-legal__updated">{t("terms.updated")}</p>
        <p className="zx-legal__lead">{t("terms.lead")}</p>
      </header>
      {[1,2,3,4,5,6,7,8].map((n) => (
        <Section key={n} title={t(`terms.s${n}Title`)} body={t(`terms.s${n}Body`)} />
      ))}
    </article>
  );
}
